import React from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import RequestUpdateAction from '../RequestUpdateAction'

const useStyles = makeStyles((theme) => ({
  subText: {
    marginBottom: theme.spacing(2),
  },
}))

const FooterContent = ({ scid }) => {
  const classes = useStyles()
  return (
    <React.Fragment>
      <Typography variant="h6">Need to update your profile?</Typography>
      <Typography
        variant="body2"
        className={classes.subText}
      >
        Information accuracy is important to us. Let us know what needs to be changed.
      </Typography>
      <RequestUpdateAction scid={scid} />
    </React.Fragment>
  )
}

FooterContent.propTypes = {
  scid: PropTypes.number.isRequired,
}

export default FooterContent
